<div class="mapsection-container" #mapSection>	
	 
	<div class="tabs-section">
		<div class="tablist" >
			<div 
				[class]="'tablist-item' +  (mapView ? ' tablist-item-active' : '')"
				(click)="onTabItemClicked(true)">
				<div class="tablist-item-link">
					<span class="tablink-text"><strong>Map view</strong></span>
				</div>	
			</div>
			<div 
				[class]="'tablist-item' +  (!mapView ? ' tablist-item-active' : '')"
				(click)="onTabItemClicked(false)">
				<div class="tablist-item-link">
					<span class="tablink-text"><strong>List view</strong></span>
				</div>	
			</div>
		</div>
	</div>
	

	<div class="map-area">	
		<div id="tabContent" class="tab-content">
			<div class="frame-2115-tDUUwq" #beachSitesListElement id="beachSitesList"
				[style]="isTabView ? !mapView ? 'display : inline-flex;' : 'display : none' : 'display : inline-flex;'">				
				
				<div class="info" *ngIf="!isTabView && sites?.length" id="desktopViewInfo">
					<span *ngIf="sites?.length && mapView" class="info">Showing <b>{{sites.length}} </b>{{ " swim " + (1 < sites.length ? "sites" : "site")}} </span>				
				</div>	

				<div class="filter-section" id="filterSection">
				
					<div class="filter-r0k1kT">
						<a 
							role="button"
							class="nsw-link nsw-link--icon" 
							(click)="onFilterResultsClick($event)" 
							[tabindex]="0" 
							href="filterResultsPanel" 
							data-bs-toggle="offcanvas"
							data-bs-target="#filterResultsPanel"
							aria-controls="filterResultsPanel" >
							<img class="icon-YrXKTt"
								src="assets/images/home/filter.svg" 
								anima-src="assets/images/home/filter.svg"
								alt="Filter">
							<span style="padding:10px;">Refine search by type or area</span>				
						</a>
					
						<a 
							role="button"
							*ngIf="filterActive" 
							class="nsw-link nsw-link--icon" 
							(click)="onClearFilterClick($event)" 
							[tabindex]="0" 
							href="javascript:void(0)">		
							<span style="padding:10px;">Clear search</span>				
						</a>
					</div>

				</div>				

				<div class="frame-2112" id="frame-2112">
					<div class="nsw-form__group" style="width:100%;">
						<label class="nsw-form__label" for="filterSitesListByKeyword">Filter list by keyword</label>
						<input type="text"
							aria-label="Filter sites by keyword"
							class="nsw-form__input" 
							id="filterSitesListByKeyword" 
							name="filterSitesListByKeyword" 
							placeholder="Filter sites"
							[(ngModel)]="filterByKeyword"
							(ngModelChange)="onFilterKeywordChanged($event)" />
					</div>
					
					<div class="filter-text-list-container">
						<div class="info" *ngIf="isTabView && sites?.length && !mapView">
							<span class="label"
							class="list-title">Showing <b>{{sites.length}} </b>{{ " swim " + (1 < sites.length ? "sites" : "site")}} </span>				
						</div>
						<div class="nsw-link-list scrollable-list" >
							<ul>
								<li *ngFor="let site of sites">								
									<app-site-link [site]="site" (siteLinkClickedEvent)="onSiteLinkClicked($event)"></app-site-link>
								</li>						  
							</ul>
						</div>				
					</div>
				</div>
			</div>

			<div id="nav-pane-mapView" aria-labelledby="nav-tab-mapview"
				[style]="isTabView ? mapView ? 'display : inline-block;' : 'display : none' : 'display : inline;'">
				<div class="info" *ngIf="isTabView && sites?.length && mapView" style="margin-bottom : 16px;">
					<span *ngIf="sites?.length && mapView" class="info">Showing <b>{{sites.length}} </b>{{ " swim " + (1 < sites.length ? "sites" : "site")}} </span>				
				</div>
				<app-beach-watch-google-map				
					[beachSites]="sites"
					[allBeachSites]="allBeachSites" 
					[siteLinkClickedEvent]="siteLinkClickedEvent$.asObservable()"
					(mapIdle)="onMapIdle($event)"
					(mapBoundsChangedEvent)="onMapBoundsChanged($event)"
					(showPopup)="displayPopup($event)"
					(closePopup)="closePopup()"
					[popupClosedEvent]="popupClosedSubject.asObservable()"
					>
				</app-beach-watch-google-map>				
			</div>	
			<div class="legend" *ngIf="!isTabView || mapView" id="legend" >
				<app-map-legend></app-map-legend>	
			</div>				
		</div>
			
	</div>
	
</div>

<div id="overlay" *ngIf="isPopupShown" (click)="closePopup()">
	<div class="map-info-window" #infowWindowContainer id="infowWindowContainer">
		<app-gmap-info-window role="dialog" #mapInfoWindow id="mapInfoWindow"
			[mobileView]="isTabView"
			[position]="popperPosition" >			
			<app-site-popup-info-widget *ngIf="popupConfig?.siteId" [closable]="true" 
				[mobileView]="isTabView"
				[sitePopupInfo]="popupConfig?.popupInfo!" (closed)="onSitePopupClosed($event)" >
			</app-site-popup-info-widget>			
		</app-gmap-info-window>
	</div>
</div>


<div    
	#filterResultsPanel
	id="filterResultsPanel"
	class="filter-sidebar offcanvas offcanvas-start" 
    data-bs-scroll="false" 
    data-bs-backdrop="true"
	[style.marginTop]="marginTop"
	[style.height]="height"	
	data-trap-focus="true"
	aria-labelledby="filterResultsPanelLabel">	
	
		
	<div class="offcanvas-header">		
		<div class="back-box">
			<a 
				class="nsw-link nsw-link--icon" 			
				[tabindex]="0" 
				href="javascript:void(0)"			
				data-bs-dismiss="offcanvas"
				data-bs-target="#filterResultsPanel">
				<img src="assets/images/home/arrow-left.svg" alt="Back">
				<span style="padding:10px;">Back</span>				
			</a>			
		</div>		
	</div>
			

	<div class="offcanvas-body">
		<app-filter-results-side-nav
			#filterResultsSideNav 
			(sitesFilterUpdate)="onSitesFilterUpdate($event)" 
			[beachSites]="allBeachSites">
		</app-filter-results-side-nav>
	</div>
</div>

